:host {
    display: block;
    font-family: soleil, sans-serif;
    font-style: normal;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
}

:host(.subtitle__1) {
    font-weight: 400;
    font-size: 18px;
    line-height: 1.4em;

    /* noinspection CssFloatPxLength */
    letter-spacing: 0.15px;
}

:host(.subtitle__2) {
    font-weight: 300;
    font-size: 12px;
    line-height: 1.2em;

    /* noinspection CssFloatPxLength */
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

:host(.subtitle__3) {
    font-weight: 500;
    font-size: 10px;
    line-height: 1.2em;

    /* noinspection CssFloatPxLength */
    letter-spacing: 0.5px;
    text-transform: uppercase;
}